import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { HRService, setupManagementUrl } from "../../../../config";
import { allLeaveTypes } from "../../../../data/Queries/HRmanagement/leavemanagement";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { leavePolicyFields } from "../../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { fetchJson } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import { data } from "autoprefixer";

const base_url = HRService.uri;

const PolicyUpdateForm = (props) => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [genders, setGenders] = useState([]);
  const [loading, setLoading] = useState(true);

   const formatDate = (date) => {
    if (!date) return null; // Handle null or undefined dates
    return date.split("T")[0]; // Extract the date part
  };
  const initialValues = {
    leaveTypeId: props.data ? props.data.LeaveTypeId : "",
  gender: props.isEditing
    ? genders.find((g) => g.Name === props.data.Gender)?.Id
    : "",    
    acrues: props.data ? props.data.Acrues : false,
    accrualRate: props.data ? props.data.AccrualRate : "",
    accrualDate: props.data ? formatDate(props.data.AccrualDate) : null,
    canCarryForward: props.data ? props.data.CanCarryForward : false,
    maxDaysCarryForward: props.data ? props.data.MaxDaysCarryForward : "",
    maxOpenApplications: props.data ? props.data.MaxOpenApplications : "",
    maxDays: props.data ? props.data.MaxDays : "",
  };

  useEffect(() => {
    async function fetchLeaveTypes() {
      try {
        const data = await fetchJson({
          objectName: "allLeaveTypes", 
          baseUrl: HRService.uri
        });
        const gender = await fetchJson({
          objectName: "allGender", 
          baseUrl: setupManagementUrl.uri
        });
         if (gender) {
          setGenders(JSON.parse(gender.results) || []);
        }
        if (data) {
          setLeaveTypes(JSON.parse(data.results) || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchLeaveTypes();
  }, []);

  const LeaveTypeOptions = leaveTypes
    ? leaveTypes.map((type) => ({
        value: type.Id,
        label: type.Type,
      }))
    : [];
     const GenderOptions = genders
    ? genders.map((gender) => ({
        value: gender.Id,
        label: gender.Name,
      }))
    : [];


  const fields = [
      {
    name: "gender",
    label: "Gender",
    type: "select",
    options: GenderOptions.map((gender) => ({
        value: gender.value,
        label: gender.label,
      })),
    required: false,
    gridColumn: "span 2",
  },
  ...leavePolicyFields,

    {
      name: "leaveTypeId",
      label: "Leave Type",
      type: "select",
      options: LeaveTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: true,
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (!values) throw new Error("Form values are undefined");
      console.log("Form Values:", values);
      console.log("Props Data:", props.data);
  
      const {
        leaveTypeId,
        accrualDate,
        maxDaysCarryForward,
        maxOpenApplications,
        maxDays,
      } = values;
  
      const acrues = values.acrues ? true : false;
      const canCarryForward = values.canCarryForward ? true : false;
      const accrualRate = values.accrualRate
        ? parseFloat(values.accrualRate)
        : null;
  
      const mutationData = {
        id: props.data?.id ?? null,
        isActive: true,
        leaveTypeId,
        gender: values.gender ?? null,
        acrues,
        accrualRate,
        accrualDate,
        canCarryForward,
        maxDaysCarryForward,
        maxOpenApplications,
        maxDays,
      };
      if (props.isEditing) {
        mutationData.id = props.data.Id;
      }
  
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updatePolicy" : "createPolicy",
        mutationData,
        props.isEditing ? "leavePolicy" : "functionParams",
        base_url
      );
  
      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Policy ${props.isEditing ? "updated" : "added"} successfully.`,
        });
      }
    } catch (error) {
      console.error("Submit error:", error); // helpful for debugging
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };
  

  return loading ? (
    <CircularProgress />
  ) : (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing?"Update Policy" : "Create Policy" }
      subtitle={props.isEditing?"Fill out the form below to update the policy." : "Fill out the form below creating a new Policy."}
    />
  );
};

export default PolicyUpdateForm;
